<div class="ra-datepicker" [class.ra-datepicker--open]="open">
  <label *ngIf="label" class="ra-datepicker__label">
    {{ label }}<span *ngIf="required" class="ra-datepicker__required"> *</span>
  </label>

  <button #trigger type="button" class="ra-datepicker__trigger" (click)="toggle()">
    <span class="ra-datepicker__value" [class.ra-datepicker__value--placeholder]="!displayText">
      {{ displayText || placeholder }}
    </span>
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" class="ra-datepicker__icon">
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.7"/>
      <path d="M3 9h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
    </svg>
  </button>

  <ng-container *ngIf="open">
    <div class="ra-datepicker__backdrop" (click)="close()"></div>
    <div class="ra-datepicker__panel" [ngStyle]="panelStyle">
      <div class="ra-datepicker__month-nav">
        <button type="button" class="ra-datepicker__nav-btn" (click)="prevMonth()">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="ra-datepicker__month-label">{{ monthLabel }}</span>
        <button type="button" class="ra-datepicker__nav-btn" (click)="nextMonth()">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="ra-datepicker__weekdays">
        <span *ngFor="let w of WEEKDAYS" class="ra-datepicker__weekday">{{ w }}</span>
      </div>
      <div class="ra-datepicker__days">
        <button
          *ngFor="let cell of days"
          type="button"
          class="ra-datepicker__day"
          [class.ra-datepicker__day--selected]="cell.selected"
          [class.ra-datepicker__day--disabled]="cell.disabled"
          [class.ra-datepicker__day--empty]="cell.empty"
          [disabled]="cell.disabled || cell.empty"
          (click)="pickDay(cell)"
        >{{ cell.label }}</button>
      </div>
    </div>
  </ng-container>
</div>
